export const isReleaseInBuild = (customerInfo) => customerInfo?.latestRelease
&& !customerInfo?.latestRelease?.zipUrl
&& !customerInfo?.latestRelease?.buildFailedMessage;
